import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { faColumns3 } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

import { useAnalyticsSelection } from "../hooks/useAnalyticsSelection";
import { COMPARISON_PARAM_PREFIX } from "../utils/analyticsUrlState";

import { DeepDiveColumn } from "./DeepDiveColumn";

export interface ComparisonColumnProps {
	header: ReactNode;
}

/**
 * The second comparison column and its own selection.
 *
 * The selection hook lives *here* rather than in the tab so that closing the
 * comparison unmounts it: a mounted hook keeps mirroring its React state back into
 * the URL, which would immediately restore the `analytics_b_*` params the toggle
 * just cleared.
 */
export const ComparisonColumn: FunctionComponent<ComparisonColumnProps> = ({ header }) => {
	const { t } = useTranslation();
	const selection = useAnalyticsSelection({ paramPrefix: COMPARISON_PARAM_PREFIX });

	return (
		<DeepDiveColumn
			isComparing
			header={header}
			placeholder={
				<div className="flex flex-col items-center text-center rounded-xl border border-dashed border-border-light px-6 py-10">
					<Icon className="w-5 h-5 text-text-disabled mb-3" icon={faColumns3} />
					<div className="text-sm font-semibold text-text">{t("analytics.compare.emptyTitle")}</div>
					<div className="text-sm text-text-meta mt-1 max-w-[320px]">
						{t("analytics.compare.emptyBody")}
					</div>
				</div>
			}
			selection={selection}
		/>
	);
};
